import { render, staticRenderFns } from "./OfficeFormComponent.vue?vue&type=template&id=0b5e6575&scoped=true&"
import script from "./OfficeFormComponent.vue?vue&type=script&lang=js&"
export * from "./OfficeFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./OfficeFormComponent.vue?vue&type=style&index=0&id=0b5e6575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5e6575",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5e6575')) {
      api.createRecord('0b5e6575', component.options)
    } else {
      api.reload('0b5e6575', component.options)
    }
    module.hot.accept("./OfficeFormComponent.vue?vue&type=template&id=0b5e6575&scoped=true&", function () {
      api.rerender('0b5e6575', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/office/OfficeFormComponent.vue"
export default component.exports